<!-- =========================================================================================
    File Name: ProductListItem.vue
    Description: Item Component - List VIew
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<!-- TODO: redo this whole card to not be sucky -->
<template>
  <vx-card class="list-view-product mb-base overflow-hidden">

    <template slot="no-body">
      <div class="vx-row no-gutter">

        <!-- IMG COL -->
        <div v-if="hasImage"
          class="vx-col sm:w-1/4 w-full product-img-container bg-white flex products-center justify-center">
          <img
            :src="helpers.getImage(product, 'secondary')"
            class="grid-view-img p-4">
          <img
            :src="helpers.getImage(product)"
            class="grid-view-img-top p-4">
        </div>

        <!-- ITEM NAME & DESC COL -->
        <div :class="`vx-col ${hasImage ? 'sm:w-1/2' : 'sm:w-3/4'}`">
          <vs-tabs :class="`vx-col ${hasImage ? '' : 'no-image-pl'}`" alignment="left">

            <template v-for="lang in helpers.getLanguages(product)">
              <vs-tab :label="lang.name" v-bind:key="lang.language_id">
                <div class="vx-row no-gutter">
                  <div class="p-1 pt-2 vx-col">

                    <h6 class="product-name font-semibold mb-1">
                      <span>{{ helpers.getLocalization(product, lang).product_name }}</span>
                    </h6>
                    <div class="text-italic" v-if="helpers.getLocalization(product, lang.language_id).product_name_tm">™: {{ helpers.getLocalization(product, lang.language_id).product_name_tm }}</div>
                    <div class="text-italic" v-if="helpers.getLocalization(product, lang.language_id).latin_name">𐌘: {{ helpers.getLocalization(product, lang.language_id).latin_name }}</div>
                    <p class="text-sm mb-4 cursor-pointer">
                      By <span class="text-primary font-semibold">{{ product.company.name }}</span>
                    </p>
                    <p class="product-description text-sm">{{ helpers.getLocalization(product, lang.language_id).description }}</p>


                  </div>
                </div>
              </vs-tab>
            </template>


          </vs-tabs>
        </div>


        <!--   ID and TYPE tags     -->
        <h1 class="product-id-top">{{ product.product_id }}</h1>
        <vs-chip v-if="!!product.product_type" color="#24c1a0" class="product-type-chip-pos">{{ product.product_type.name }}</vs-chip>

        <!-- PURCHASE COL -->
        <div class="vx-col p-2 sm:w-1/4 w-full flex products-center border border-solid d-theme-border-grey-light border-r-0 border-t-0 border-b-0">
          <div class="vx-row no-gutter w-full">
            <div class="vx-col">
              <div>
                <vs-chip v-if="product.active" color="success">Active</vs-chip>
                <vs-chip v-else color="warning">Inactive</vs-chip>
              </div>


            </div>
            <div class="vx-row no-gutter w-full">
              <div class="vx-col">
                <vs-button @click="editProduct(product.product_id)" style="position:absolute;bottom:1em;right:1em;">
                  <feather-icon icon="EditIcon" svgClasses="h-4 w-4"/>
                  <span class="text-sm font-semibold ml-2">EDIT</span>
                </vs-button>
              </div>
            </div>
          </div>
        </div>

      </div>
    </template>

  </vx-card>
</template>

<script>
  import types from '@/models';
  import { productHelpers } from '@/models/helpers';

  export default {
    data() {
      return {
        helpers: productHelpers,
      }
    },
    props: {
      product: {
        type: types.Product,
        required: true
      },
    },
    computed: {
      hasImage() {
        return productHelpers.getImage(this.product) !== '' && productHelpers.getImage(this.product, 'secondary') !== '';
      },
      englishName() {
        if (this.product.localizations && this.product.localizations.length > 0)
          return this.product.localizations[0].product_name;
        return 'unknown';
      },
    },
    methods: {
      editProduct(productId) {
        this.$emit('editProduct', productId);
      }
    }
  }
</script>

<style lang="scss" scoped>
  .no-image-pl {
    padding-left: 100px;
  }
  .list-view-product {

    .product-name, .product-description {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    .product-name {
      -webkit-line-clamp: 2;
    }

    .product-description {
      -webkit-line-clamp: 5;
    }

    .grid-view-img {
      max-width: 100%;
      max-height: 100%;
      width: auto;
      transition: .35s;
    }

    .grid-view-img-top {
      position: absolute;
      left: 0;
      max-width: 100%;
      max-height: 100%;
      width: auto;
      transition: .35s;
    }

    .product-id-top {
      position: absolute;
      left: 15px;
      top: 15px;
      transition: .35s;
    }
    .product-type-chip-pos {
      position: absolute;
      left: 15px;
      bottom: 15px;
      transition: .35s;
    }

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, .25);

    }
  }
</style>
